import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCar3: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="car-3"><path d="M20 17.25H22.25V15.099C22.25 12.1342 20.1573 9.33146 17.25 8.75L14 4.75H7.46208C4.21434 4.75 1.75 7.25 1.75 11.3319V17.25H4.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.25 18H15V16.5H14.25V18ZM9.75 17.25V18H14.25V17.25V16.5H9.75V17.25Z" fill="currentColor"/><circle cx="7" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/><circle cx="17" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCar3;
